import { AgentInstructions } from "../types";
import { timeAgo } from "./timeAgo";

/** Shown after a save: open conversations keep the rules they already read. */
export const AGENT_INSTRUCTIONS_SAVED_MESSAGE =
  "Saved. New conversations use these rules. In a conversation that is open now, tell the agent to read the rules again.";

/**
 * "Last changed by Grok, 2 hours ago" — the connection's name when an agent
 * saved, "you" when the person saved in an app. null before the first save.
 */
export function lastChangedLine(
  instructions: AgentInstructions,
  now: number = Date.now(),
): string | null {
  if (!instructions.updated_at) return null;
  const who = instructions.changed_by ?? "you";
  return `Last changed by ${who}, ${timeAgo(instructions.updated_at, now)}`;
}
